import { CellClassParams } from 'ag-grid-community';
import {GridName, StorageName} from './../../../shared/model/ag-grid-common-constant'


export class AgGridI {
  colDefs: AgColDefsI[];
  rowSelection: "single" | "multiple";
  rows?:any[];
  storageName?: GridName;
  filterStorageName?:GridName;
  apiUrl? : string;
  sortStorageName? : GridName;
  initialRows?: GridName;
  paginationStorageName? : StorageName;
  addBlankRowOnEnter?:boolean;
  columnSettings?:boolean;
  singleClickEdit?:boolean;
  tableId? : GridName;
  isServerSidepagination?: boolean = false;
  tabIndex?: number;
  showPagination?: boolean = false;
  showFilter? : boolean = false;
  headerHeight? : number;
  rowHeight? : number;
  isFilter?:boolean=false;
  floatingDropDown?:boolean=false;
  floatingMultiselectDropDown?: boolean =false;
  tableIndex?: number =0;
  filterIdColumnName?:string;
  moreButton?:boolean=true;
  selectAll?:boolean=true;
  editable?:boolean=true;
  headerComponentParams?:{};
  columnTypes?: any;
  columnCellType? : any;
  handleCustomHeaderDisplay?:boolean=true;
  context?:any;
}

 export class  commonGridOptions {
  defaultColDef: {
    width: 100, // Set the common width for all columns
  }
  // Other common grid options can be added here
};

 export class AgColDefsI {
  wrapText?:boolean;
  resizable?:boolean;
    headerName?: string;
    headerClass?:string | ((params: CellClassParams) => any);;
    field: string;
    suppressMovable?:boolean;
    lockPosition?: boolean | 'left' | 'right' | null;
    lockPinned?: boolean;
    width?: number ;
    minWidth?: number;
    maxWidth?: number;
    editable?: any| false;
    sortable?: boolean | false;
    isfilter?: boolean | false; // to display filter icon in header
    pinned?: boolean | 'left' | 'right' | null;
    headerCheckboxSelection?: boolean | false | any;
    checkboxSelection?: boolean | false | any;
    //cellClass?: string;
    cellClass?: string  | ((params: CellClassParams) => any);
    hide?: boolean;
    cellClassRules?:any;
    cellStyle?:any
    cellRenderer?:any;
    cellRendererParams?:any;
    cellEditor?:any;
    headerComponent?:any;
    suppressMenu?:boolean;
    headerComponentParams?:any;
    tooltipField?:any;
    flex?:number;
    uniqueName?:string = '';
    AgGridColumnsSettingComponent?:boolean;
    cellRendererSelector?:any;
    cellEditorParams?:any;
    tooltipValueGetter?: (params: any) => string;
    valueGetter?:any;
 }
 export const defaultPageLimit = 25;

export class PaginationBaseModel {
    sortColumn   : string='';
    sortDirection: string = '';
    pageNumber   : number = 1;
    pageSize     : number = 25;
    searchText   : string = '';
    getAll       : boolean = false;
}
export class TableHistoryModel extends PaginationBaseModel{
  companyId: string='';
}

export class TableCertificationModel extends PaginationBaseModel{
  vendorId: string='';
}
export class TableSourcingRequirementModel extends PaginationBaseModel{
  sourcingId : string = '';
  filterList : string[] = [];
  step : number = 1
}
export class TableSourcingRFQResultModel extends PaginationBaseModel{
  requirementId: string = '';
  vendorId: string = '';
  contactId: string = '';
}

export class TableSouringPaginationModel extends PaginationBaseModel{
  stage?     : string='All';
  dateRange?   : string="";
  statusId?: string="";
}
export class TablePaginationModel extends PaginationBaseModel{
  id        : string='';
  isActive  : boolean=true;
  stage     : string='All';
  filters   : string="";
  exportAsPdf: boolean;
  selectedId: number[];
  companyId : string='';
  categoryId  :string='0'
  filtersFromPopup: string = "";
  companyOrVendorId: string
  documentTypeId: number;
  searchCompanyText : string = ''
}
export class TablePaginationPartRequirementModel extends PaginationBaseModel{
  id        : string='';
  isActive  : boolean=true;
  stage     : string='All';
  filters   : string="";
  companyId : string='';
  categoryId  :string='0'
  filtersFromPopup: string = "";
  searchCompanyText : string = ''
  partId : string = '';
}
export class LineHistoryPaginationModel extends PaginationBaseModel{
  inventoryLineId: string | null;
}
export class FilesPaginationModel extends PaginationBaseModel{
  partId: string = '';
  categoryId: string = '';
}
export class OfferPaginationModel extends PaginationBaseModel{
  partId: string = '';
  filtersFromPopup: string = '';
}
export class VPLPaginationModel extends PaginationBaseModel{
  partId: string = '';
  vendorId: string = '';
  filtersFromPopup: string = '';
}


export class InStockPaginationModel extends PaginationBaseModel{
  id: string | null;
  filtersFromPopup: string = '';
}
export class ConsignmentPaginationModel extends InStockPaginationModel{
  companyId: string | null;
}
export class AlternativePaginationModel extends PaginationBaseModel{
  partId: string | null;
  mfrId: string | null;
}

export class PartListPaginationModel extends PaginationBaseModel{
  mfrId:string='';
  filtersFromPopup:string;
  isConsignment:boolean = false

}

export class VendorPartLibraryPaginationModel extends PaginationBaseModel{
  mfrId: string ='';
  vendorId: string;
  filtersFromPopup: string;
}

export class OemExcessPaginationModel extends PaginationBaseModel{
  mfrId: string ='';
  companyId: string;
  filtersFromPopup: string;
}

export class TablePaginationModelContact extends PaginationBaseModel{
  filtersFromPopup  : string = "";
  filters           : string="";
  id                : string='';
}
export class TablePaginationModelVendorList extends TablePaginationModel{
  stage    : string ="";
  id       : string ="";
  vendor?: string ="";
  vendorTypeId? = '';
  mfrId? = '';
  tagId?: string ="";
  isShowAVL? = false
  isShowNoNAVL? = false
}
export class TablePaginationModelMSVList extends PaginationBaseModel{
  vendor            : string ="";
  vendorTypeId      : string ="";
  mfrId             : string ="";
  isShowAVL         : boolean =false;
  isShowNoNAVL      : boolean =false;
}
export class AgGridPaginationConfig  extends PaginationBaseModel {
  rows              : any[] = [];
  totalRecords      : number=0;
  pageSize          : number = 25;
  getAll            : boolean= false;
  searchText        : string = '';
  currentPageNumber : number = 1;
  tableOffset       : number = 0;

  limitOptions = [
    {
      key: '10',
      value: 10
    },
    {
      key: '25',
      value: 25
    },
    {
      key: '50',
      value: 50
    },
    {
      key: '75',
      value: 75
    },
    {
      key: '100',
      value: 100
    },
    {
      key: 'All',
      value: 1
    },
  ];
}

export class UpdateCellData{
  companyId: number;
  operationId: number;
  data: string ;
  // saleStageId: string ;
  // leadScoreId: string ;
  // intentToBuyId: string ;
  // companyIds:string []
}
export class SourceVendorFilter extends PaginationBaseModel{
  selectAllChecked: boolean = false ;
  vendorTypeId: string = '' ;
  dateRange: string = '' ;
  statusId: string = '' ;
}
export class SendRFQsFilterModel{
  sortColumn: string = '';
  sortDirection: string = '';
  pageNumber: number = 1;
  pageSize: number = 10;
  searchText: string = '';
  getAll: boolean = false;
  vendorTypeId: string = '';
  sortById: string = '';
  sourcingBatchId: string = "";
  requirementId: string = "";
  pendingSendOnly: boolean = false;
  vendorWise: boolean = false;
}
export class UpdateCellDataIntentToBuy{
  // companyId: number;
   //operationId: number;
   //data: string ;
   saleStageId: string ;
   leadScoreId: string ;
   intentToBuyId: string ;
   companyIds:string [] =[]
 }
 export class UpdateStatus{
   companyId: string = '';
   contactId: string = '';
   active:boolean;
 }
 export class UpdateOverallRatingStatus{
  companyId: string = '';
  overallRating:number;
  currentUrl:string
}
export class UpdateQuickNotes{
  companyId: string = '';
  notes: string = '';
}

 export class UpdateVendorStatus{
  contactId: string = '';
  vendorId: string = '';
  active:boolean;
}

 
export class SaveUserSetting{
    userId      : string;
    userSetting : string;

}